import { cn } from 'utils';
import Text from '../Text';

interface Props {
  title: string;
  description: string;
  className?: string;
}

const DescriptionBar = ({ title, description, className }: Props) => {
  return (
    <div className={cn('w-full text-wrap border-b border-border-dimmed p-6 padding-md', className)}>
      <h2 className="mb-2 text-heading2 font-medium">{title}</h2>
      <Text size="body2" weight="regular" color="description" className='whitespace-line'>
        {description}
      </Text>
    </div>
  );
};

export default DescriptionBar;
